function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-miterlimit:10;stroke-width:.75px}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "prefix__Group_14",
  "data-name": "Group 14",
  transform: "translate(-2111.006 -1598.123)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "prefix__Ellipse_10",
  cx: 4.213,
  cy: 4.213,
  r: 4.213,
  className: "prefix__cls-1",
  "data-name": "Ellipse 10",
  transform: "rotate(-25.373 4615.392 -3892.757)"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix__Path_11",
  d: "M2126.368 1683.134a7.651 7.651 0 0 0-14.912-.037",
  className: "prefix__cls-1",
  "data-name": "Path 11",
  transform: "translate(0 -68.732)"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix__Path_12",
  d: "M2143.847 1701.78a4.534 4.534 0 0 0-8.837-.022",
  className: "prefix__cls-1",
  "data-name": "Path 12",
  transform: "translate(-20.608 -87.169)"
}));

var SvgDrivers = function SvgDrivers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.811,
    height: 16.936,
    viewBox: "0 0 15.811 16.936",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDrivers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/drivers.f8a242e7.svg";
export { ForwardRef as ReactComponent };